import { Box, Typography } from '@mui/material'
import Icon from '@mui/material/Icon'

const HeaderTextManageApplicant = ({ data }) => {
  //change date format
  const date = new Date(data?.expired_date)
  const formattedDate = date.toLocaleDateString('en-GB', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
  })

  return (
    <Box display="flex" alignItems="center" justifyContent="space-between">
      <Box display="flex" columnGap={2} alignitems="center">
        <Box>
          <Box display="flex" alignItems="center" columnGap={2}>
            <Typography
              variant="h3"
              color="dark-text.main"
              marginBottom={0.5}
              align="left"
              sx={{
                textTransform: 'capitalize',
              }}
            >
              {data?.position_title}
            </Typography>
          </Box>
          <Box display="flex" alignItems="center" columnGap={3}>
            <Box display="flex" alignItems="center" columnGap={1}>
              {/* inactive/expired job ads  */}
              {data?.advertisement_status === 3 || data?.advertisement_status === 2 ? (
                <Typography component="span" variant="body1" color="light-gray-text.main">
                  Inactive
                </Typography>
              ) : null}

              {/* active job ads   */}
              {data?.advertisement_status === 1 ? (
                <Box display="flex" alignItems="center" columnGap={1}>
                  <Typography component="span" variant="body1" color="positive.main">
                    Active
                  </Typography>
                  <Icon sx={{ fontSize: 7, color: 'light-gray-text.main' }}>circle</Icon>
                  <Typography component="span" variant="body1" color="light-gray-text.main">
                    Expires on {formattedDate}
                  </Typography>
                </Box>
              ) : null}
            </Box>
          </Box>
        </Box>
      </Box>
    </Box>
  )
}
export default HeaderTextManageApplicant
